module.exports = __webpack_public_path__ + "img/fullname_2rows_blue.ca2d94d1.svg";